import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../utils/api";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const Performance = () => {
  const { id } = useParams();
  const [overallPerformance, setOverallPerformance] = useState([]);
  const [subjectWiseData, setSubjectWiseData] = useState([]);
  const [limit, setLimit] = useState(5); // Default limit is 5

  async function fetchPerformance() {
    const programType = "getAllExamDetailsForTeacher";

    const fd = new FormData();
    fd.append("studentId", id);
    fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
    fd.append("token", localStorage.getItem("authToken"));
    fd.append("programType", programType);
    fd.append("limit", limit); // Use selected limit

    for (let pair of fd.entries()) {
        console.log(pair[0] + ": " + pair[1]);
    }


    try {
      const response = await api.post("examPaper/exam", fd);
      // console.log("Fetched result:", response);

      if (response.data.success) {
        let totalCorrect = 0;
        let totalWrong = 0;
        let totalAttempted = 0;

        // Aggregate all exams
        response.data.data.forEach((exam) => {
          totalCorrect += parseInt(exam.correctAnswers, 10);
          totalWrong += parseInt(exam.wrongAnswers, 10);
          totalAttempted += parseInt(exam.totalAnsweredQuestions, 10);
        });

        setOverallPerformance([
          {
            category: "Performance",
            correctAnswers: totalCorrect,
            wrongAnswers: totalWrong,
            totalQuestions: totalAttempted,
          },
        ]);

        // Extract subject-wise data
        let subjectsMap = {};
        response.data.data.forEach((exam) => {
          exam.subjectScores.forEach((subject) => {
            if (!subjectsMap[subject.subjectId]) {
              subjectsMap[subject.subjectId] = {
                subjectName: subject.subjectName,
                total: 0,
                correct: 0,
              };
            }
            subjectsMap[subject.subjectId].total += subject.total;
            subjectsMap[subject.subjectId].correct += subject.correct;
          });
        });

        // Convert subject-wise data to an array
        const formattedSubjectData = Object.values(subjectsMap).map(
          (subject) => ({
            subjectName: subject.subjectName,
            totalQuestions: subject.total,
            correctAnswers: subject.correct,
            wrongAnswers: subject.total - subject.correct,
          })
        );

        setSubjectWiseData(formattedSubjectData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  // Fetch performance data whenever `limit` changes
  useEffect(() => {
    fetchPerformance();
  }, [limit]);

  return (
    <div className="dashboard-body">
      {/* Dropdown to select limit */}
      <div className="mb-4">
        <label htmlFor="limitSelect" className="fw-bold me-2">Select Limit:</label>
        <select
          id="limitSelect"
          className="form-select d-inline w-auto"
          value={limit}
          onChange={(e) => setLimit(parseInt(e.target.value, 10))}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
        </select>
      </div>

      {/* Overall Performance Chart */}
      <div className="card mb-15">
        <div className="card-header">
          <h4 className="card-title">Overall Performance</h4>
        </div>
        <div className="card-body">
          {overallPerformance.length > 0 ? (
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={overallPerformance} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="category" />
                <YAxis />
                <Tooltip />
                <Legend wrapperStyle={{ marginTop: 20, paddingTop: 20 }} />
                <Bar dataKey="correctAnswers" fill="#4caf50" name="Correct Answers" />
                <Bar dataKey="wrongAnswers" fill="#f44336" name="Wrong Answers" />
                <Bar dataKey="totalQuestions" fill="#2196f3" name="Total Attempted" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="text-center">No performance data available.</p>
          )}
        </div>
      </div>

      {/* Subject-wise Performance Chart */}
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Subject-wise Performance</h4>
        </div>
        <div className="card-body">
          {subjectWiseData.length > 0 ? (
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={subjectWiseData} margin={{ top: 20, right: 30, left: 20, bottom: 15 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="subjectName" />
                <YAxis />
                <Tooltip />
                <Legend wrapperStyle={{ marginTop: 20, paddingTop: 20 }} />
                <Bar dataKey="correctAnswers" fill="#4caf50" name="Correct Answers" />
                <Bar dataKey="wrongAnswers" fill="#f44336" name="Wrong Answers" />
                <Bar dataKey="totalQuestions" fill="#2196f3" name="Total Questions" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="text-center">No subject-wise data available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Performance;
